import clsxm from '@sly/frontend/common/lib/clsxm';
import { parse } from 'node-html-parser';
import { DynamicEditorProps } from 'sly/hubPage/components/HubDynamicContent/DynamicEditor/DynamicEditor.types';

const s3Regex =
  /^https:\/\/seniorly\.s3\.[^.]+\.amazonaws.com\/uploads\/(?<path>.+)/;

const sizes =
  '(max-width: 727px) calc(100vw - 2rem), (max-width: 1079px) 502px, 678px';

const imageWidths = [360, 480, 502, 678, 360 * 3, 480 * 3, 502 * 3, 678 * 3];

function transformContentImages(value: string) {
  const htmlBody = parse(value);

  const images = htmlBody.querySelectorAll('img').filter((image) => {
    const src = image.getAttribute('src');
    if (!src) return false;
    const path = src.match(s3Regex)?.groups?.path;
    if (path) {
      image.setAttribute('data-path', path);
    }
    return !!path;
  });

  if (!images.length) return value;

  images.forEach((image) => {
    const path = image.getAttribute('data-path');
    const sources = imageWidths.map(
      (w) => `https://cdn.seniorly.com/images/${w}x/${path} ${w}w`
    );

    image.setAttribute('src', sources[5]);
    image.setAttribute('srcset', sources.join(', '));
    image.setAttribute('sizes', sizes);
  });

  return htmlBody.toString();
}

export default function DynamicEditor({
  content,
  isGeoGuidePage = false,
}: DynamicEditorProps) {
  if (!content) return null;

  return (
    <div
      className={clsxm(
        'dynamic-editor',
        isGeoGuidePage
          ? 'w-auto'
          : 'w-[calc(100%-2rem)] md:w-[var(--col6)] lg:w-[var(--col8)]'
      )}
      dangerouslySetInnerHTML={{ __html: transformContentImages(content) }}
      data-tp-id='gen-div-7c8776ae-e4f6-4942-9979-b6a3b59f577a'
    />
  );
}
